"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStateMachine = void 0;
var _react = require("react");
var _constants = require("../constants");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var reducer = function reducer(prevState, action) {
  var steps = prevState.steps,
    currentStep = prevState.currentStep,
    isLoading = prevState.isLoading;
  var isSecondLastStep = currentStep === steps.length - 1;
  if (action.type === 'NEXT_STEP') {
    if (currentStep === steps.length) {
      return prevState;
    }
    if (currentStep < steps.length - 2) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        currentStep: currentStep + 1
      });
    }
    if (isLoading == null) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        currentStep: currentStep + 1
      });
    }
    if (currentStep < steps.length - 1 && isLoading) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        currentStep: currentStep + 1
      });
    }
    if (isLoading === false) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        currentStep: steps.length
      });
    }
  }
  if (action.type === 'LOADING_CHANGED') {
    return _objectSpread(_objectSpread({}, prevState), {}, {
      isLoading: action.payload,
      currentStep: isSecondLastStep && action.payload === false ? steps.length : currentStep
    });
  }
  return prevState;
};
var useStateMachine = exports.useStateMachine = function useStateMachine(steps, onFinish, loadingTimeout, onLoadingTimeout, isLoading) {
  var _useReducer = (0, _react.useReducer)(reducer, {
      steps: steps,
      currentStep: 1,
      isLoading: isLoading
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    timeoutError = _useState4[0],
    setTimeoutError = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    secondLastStepShown = _useState6[0],
    setSecondLastStepShown = _useState6[1];
  var isLastStep = state.currentStep === steps.length;
  var isSecondLastStep = state.currentStep === steps.length - 1;
  if (isSecondLastStep && !secondLastStepShown) setSecondLastStepShown(true);
  var showSecondLastStep = secondLastStepShown || isSecondLastStep && (isLoading == null || isLoading);
  (0, _react.useEffect)(function () {
    if (isSecondLastStep && isLoading) {
      setTimer(setTimeout(function () {
        setTimeoutError(true);
        onLoadingTimeout();
      }, loadingTimeout));
    }
    var timeout = setTimeout(function () {
      return dispatch({
        type: 'NEXT_STEP'
      });
    }, _constants.ANIMATION_INTERVAL_DURATION);
    if (isLastStep && !timeoutError) {
      setTimeout(onFinish, _constants.ANIMATION_INTERVAL_DURATION);
    }
    return function () {
      return clearTimeout(timeout);
    };
  }, [steps, state.currentStep]);
  (0, _react.useEffect)(function () {
    dispatch({
      type: 'LOADING_CHANGED',
      payload: isLoading
    });
    if (isLoading === false) {
      clearTimeout(timer);
    }
  }, [isLoading]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isLastStep: isLastStep,
    timeoutError: timeoutError,
    showSecondLastStep: showSecondLastStep
  });
};